import { render, staticRenderFns } from "./DetailedReport.vue?vue&type=template&id=44b5ab25&"
import script from "./DetailedReport.vue?vue&type=script&lang=js&"
export * from "./DetailedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports